import { Flower2, Flower, Sparkle } from "lucide-react";
import HeroGrid from "./HeroGrid";
import HeroSide from "./HeroSide";
import HeroBottom from "./HeroBottom";

export default function Hero() {
  return (
    <section
      className="relative pt-10 md:pt-16 pb-16 md:pb-20 overflow-hidden bg-white"
      data-testid="hero-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        {/* Doodles around the headline */}
        <Flower2
          className="pointer-events-none absolute top-2 left-6 md:left-16 text-[#FFE14D] fill-[#FFE14D] spin-slow hidden md:block"
          size={30}
        />
        <Flower
          className="pointer-events-none absolute top-6 right-6 md:right-20 text-[#F97316] fill-[#F97316] bounce-soft hidden md:block"
          size={28}
        />
        <Sparkle
          className="pointer-events-none absolute top-[86px] left-[27%] text-[#FFE14D] fill-[#FFE14D] float-x hidden lg:block"
          size={22}
        />

        <h1
          className="display text-center text-[38px] sm:text-[52px] md:text-[64px] lg:text-[76px] leading-[1.04] tracking-tight fade-up max-w-[980px] mx-auto"
          data-testid="hero-headline"
        >
          Make Your Brand Look{" "}
          <br className="hidden sm:block" />
          More{" "}
          <span className="relative inline-block">
            <span className="relative z-10">Charming</span>
            <span className="absolute left-0 right-0 bottom-1 md:bottom-2 h-3 md:h-4 bg-[#FFE14D] -z-0 rounded-sm" />
          </span>{" "}
          Online
        </h1>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-4 items-center">
          <HeroSide side="left" />
          <div className="md:col-span-8 fade-up-delay-2">
            <HeroGrid />
          </div>
          <HeroSide side="right" />
        </div>

        <HeroBottom />
      </div>
    </section>
  );
}
